import type { SVGProps } from "react";

const SvgCRM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="50px"
    width="50px"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    {...props}
  >
    <g strokeWidth=""></g>
    <g strokeLinecap="round" strokeLinejoin="round"></g>
    <g>
      <g>
        <g>
          <path d="M478.33,68.409H33.67C15.105,68.409,0,83.514,0,102.079v307.841c0,18.566,15.105,33.67,33.67,33.67h444.66 c18.566,0,33.67-15.105,33.67-33.67V102.079C512,83.514,496.895,68.409,478.33,68.409z M119.716,427.557H33.67 c-9.725,0-17.637-7.912-17.637-17.637V102.079c0-9.725,7.912-17.637,17.637-17.637h86.046V427.557z M495.967,409.921 c0,9.725-7.912,17.637-17.637,17.637h-342.58V84.443h342.58c9.725,0,17.637,7.912,17.637,17.637V409.921z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M196.142,102.614h-34.205c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h34.205 c4.427,0,8.017-3.589,8.017-8.017S200.569,102.614,196.142,102.614z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M93.528,102.614H42.221c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h51.307 c4.427,0,8.017-3.589,8.017-8.017S97.956,102.614,93.528,102.614z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M93.528,188.125H42.221c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h51.307 c4.427,0,8.017-3.589,8.017-8.017S97.956,188.125,93.528,188.125z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M93.528,256.534H42.221c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h51.307 c4.427,0,8.017-3.589,8.017-8.017S97.956,256.534,93.528,256.534z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M93.528,324.944H42.221c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h51.307 c4.427,0,8.017-3.589,8.017-8.017S97.956,324.944,93.528,324.944z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M93.528,222.33H42.221c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h51.307c4.427,0,8.017-3.589,8.017-8.017 S97.956,222.33,93.528,222.33z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M93.528,290.739H42.221c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h51.307 c4.427,0,8.017-3.589,8.017-8.017S97.956,290.739,93.528,290.739z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M76.426,376.251H42.221c-4.427,0-8.017,3.589-8.017,8.017c0,4.427,3.589,8.017,8.017,8.017h34.205 c4.427,0,8.017-3.589,8.017-8.017C84.443,379.84,80.853,376.251,76.426,376.251z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M76.426,136.818H42.221c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h34.205 c4.427,0,8.017-3.589,8.017-8.017S80.853,136.818,76.426,136.818z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M264.551,102.614h-34.205c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h34.205 c4.427,0,8.017-3.589,8.017-8.017S268.979,102.614,264.551,102.614z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M332.96,102.614h-34.205c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h34.205 c4.427,0,8.017-3.589,8.017-8.017S337.388,102.614,332.96,102.614z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M401.37,102.614h-34.205c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h34.205 c4.427,0,8.017-3.589,8.017-8.017S405.797,102.614,401.37,102.614z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M469.779,102.614h-34.205c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h34.205 c4.427,0,8.017-3.589,8.017-8.017S474.206,102.614,469.779,102.614z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M252.266,283.797c-3.54-2.659-8.566-1.945-11.224,1.595c-6.636,8.833-16.768,13.899-27.798,13.899 c-19.155,0-34.739-15.584-34.739-34.739s15.584-34.739,34.739-34.739c11.038,0,21.176,5.073,27.81,13.917 c2.657,3.541,7.682,4.26,11.223,1.602s4.258-7.682,1.602-11.223c-9.693-12.92-24.503-20.329-40.636-20.329 c-27.995,0-50.772,22.777-50.772,50.772s22.777,50.772,50.772,50.772c16.12,0,30.924-7.4,40.617-20.303 C256.521,291.481,255.807,286.456,252.266,283.797z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M331.35,280.396c15.247-3.209,26.73-16.76,26.73-32.948c0-18.566-15.105-33.67-33.67-33.67h-42.756 c-4.427,0-8.017,3.589-8.017,8.017v85.511c0,4.427,3.589,8.017,8.017,8.017s8.017-3.589,8.017-8.017v-26.188h22.18l23.248,30.998 c1.576,2.1,3.983,3.207,6.42,3.207c1.674,0,3.362-0.523,4.804-1.603c3.541-2.656,4.26-7.682,1.603-11.223L331.35,280.396z M289.67,265.086v-35.273h34.739c9.725,0,17.637,7.912,17.637,17.637s-7.912,17.637-17.637,17.637H289.67z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M469.205,306.508l-8.551-85.51c-0.368-3.675-3.198-6.623-6.855-7.14c-3.653-0.518-7.194,1.531-8.565,4.961l-26.762,66.903 l-26.762-66.903c-1.372-3.429-4.908-5.474-8.565-4.961c-3.657,0.517-6.487,3.465-6.855,7.14l-8.551,85.511 c-0.44,4.406,2.774,8.334,7.18,8.775c4.401,0.44,8.333-2.774,8.775-7.18l5.293-52.927l22.043,55.107 c1.218,3.043,4.164,5.039,7.443,5.039s6.226-1.996,7.443-5.039l22.043-55.107l5.293,52.927c0.414,4.134,3.898,7.219,7.968,7.219 c0.267,0,0.536-0.013,0.807-0.041C466.431,314.843,469.645,310.914,469.205,306.508z"></path>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgCRM;
